import { getPlatformRegion } from '../utils';

const platformLanguage = getPlatformRegion();

export default (state) => {
  return {
    ...state,
    uiSettings: {
      ...state.uiSettings,
      platformLanguage,
    },
  };
};
